// doctor-frontend/src/pages/chc/MODashboard.jsx
// Workbench for Medical Officers in the CHC flow. Allows MO to create
// new citizen visits, record history/exam, order lab and radiology
// investigations, write prescriptions and submit the encounter. This
// component is a placeholder and should be extended with forms and
// tables to manage encounters.

import React from 'react';
import { Box, Typography } from '@mui/material';

export default function MODashboard() {
  return (
    <Box p={2} className="min-h-screen">
      <Typography variant="h6" gutterBottom>
        Medical Officer Workbench
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Create new visits, record history and examination, order lab
        investigations or imaging, and write prescriptions for patients.
      </Typography>
      {/* Future enhancements: search citizen, add visit, display active
          orders and prescriptions. */}
    </Box>
  );
}